export const START_NEW_ORDER_EVENT = 'ash:start-new-order'
export const START_NEW_DROP_SHIPMENT_ORDER_EVENT = 'ash:start-new-drop-shipment-order'
export const START_NEW_KIT_REGISTRATION_EVENT = 'ash:start-new-kit-registration'
export const DROP_SHIPMENT_ORDER_STATE_EVENT = 'ash:drop-shipment-order-state'

export type DropShipmentOrderStateDetail = {
  isCompleted: boolean
}
